<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";

const router = useRouter();
const { login } = useAuth();

const email = ref("");
const password = ref("");
const isLoading = ref(false);
const isSuccess = ref(true);

const rules = reactive({
  email: {
    required,
    minLength: minLength(4),
  },

  password: {
    required,
    minLength: minLength(6),
  },
});

// @ts-ignore
const v$: any = useVuelidate(rules, { email, password });

async function submit() {
  isLoading.value = true;
  try {
    await login(email.value, password.value);
  } catch (error) {
    console.log(error);
    isSuccess.value = false;
  } finally {
    isLoading.value = false;
    return await navigateTo("/");
  }
}

function resetSuccess() {
  isSuccess.value = true;
}
</script>

<template>
  <div>
    <div class="min-h-screen min-w-screen flex">
      <div class="w-full m-auto min-w-80 max-w-120">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mx-4 mb-4">
          <div class="identity-input mb-4">
            <label
              for="identity"
              class="block text-gray-700 text-sm font-bold mb-2"
            >
              Email</label
            >
            <p-input placeholder="e-mail" v-model="email"></p-input>
            <div>
              <span
                v-if="v$.email.$error && !v$.email.required"
                class="font-sans text-base text-red"
                >Обязательное поле</span
              >
            </div>
          </div>

          <div class="password-input mb-6">
            <label
              for="identity"
              class="block text-gray-700 text-sm font-bold mb-2"
              >Password</label
            >

            <p-input
              placeholder="password"
              v-model="password"
              show-password
            ></p-input>
            <div>
              <span
                v-if="v$.password.$error && !v$.password.minLength"
                class="font-sans text-base text-red"
                >Пароль не должен быть короче 6 символов</span
              >
              <span v-if="!isSuccess" class="font-sans text-base text-red"
                >Не верно указана почта и(или) пароль. Пожалуйста, проверьте
                введённые данные и попробуйте ещё раз.</span
              >
            </div>
          </div>

          <div class="flex items-center justify-center">
            <p-button
              type="primary"
              rounded
              :loading="isLoading"
              @click="submit"
              class="min-w-40"
              >Войти</p-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
